import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import EvaluacionesHome from './components/EvaluacionesHome';
import EvaluationForm from './modules/EvaluationForm/EvaluationForm';
import AutoEvaluationForm from './modules/AutoEvaluation/AutoEvaluationForm';
import MyEvaluationsList from './modules/MyEvaluations/MyEvaluationsList';
import TeamEvaluations from './modules/TeamEvaluations/TeamEvaluations';
import AllEvaluations from './modules/AllEvaluations/AllEvaluations';
import CalibrationDashboard from './components/CalibrationDashboard';
import CalibrateEvaluations from './modules/CalibrateEvaluations/CalibrateEvaluations';
import TrendsDashboard from './modules/TrendsDashboard/TrendsDashboard';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<EvaluacionesHome />} />
        <Route path="/tendencias" element={<TrendsDashboard />} />
        <Route path="/crear-evaluacion" element={<EvaluationForm />} />
        <Route path="/crear-autoevaluacion" element={<AutoEvaluationForm />} />
        <Route path="/mis-evaluaciones" element={<MyEvaluationsList />} />
        <Route path="/equipo-evaluaciones" element={<TeamEvaluations />} />
        <Route path="/todas-las-evaluaciones" element={<AllEvaluations />} />
        <Route path="/calibrar" element={<CalibrationDashboard />} />
        <Route path="/calibrar-evaluaciones" element={<CalibrateEvaluations />} />
        <Route path="/calibracion" element={<CalibrationDashboard />} />
        {/* Podés agregar el resto de las rutas luego */}
      </Routes>
    </Router>
  );
}

export default App;
